import { Chart, registerables } from "chart.js";
import ActivityLogListing from "../../components/incident_management/ActivityLogListing.vue";
import IncidentManagement from "../../components/incident_management/IncidentManagement.vue";
import IncidentInvestigationForm from "../../components/incident_management/IncidentInvestigationForm.vue";
import IncidentInvestigationView from "../../components/incident_management/IncidentInvestigationView.vue";
import IncidentManagementReport from "../../components/incident_management/IncidentManagementReport.vue";
import IncidentReportView from "../../components/incident_management/IncidentReportView.vue";
import IncidentReportsListing from "../../components/incident_management/IncidentReportsListing.vue";
import InitialReportForm from "../../components/incident_management/InitialReportForm.vue";
import { uuidPattern } from "../../lib/raft_generic_helper";
import jsonapiClient from "../../lib/jsonapi_client";

Chart.register(...registerables);

require("./css/incident_management.css");

const routes = [
  {
    path: "/raft/incident-management/incident-report/create",
    name: "incident_management_report_incident",
    component: InitialReportForm,
  },
  {
    path:
      "/raft/incident-management/incident-report/:reportUuid(" +
      uuidPattern +
      ")/view",
    name: "incident_report_view",
    component: IncidentReportView,
    props: true,
  },
  {
    path:
      "/raft/incident-management/incident-investigation/:uuid(" +
      uuidPattern +
      ")/view",
    alias:
      "/raft/incident-management/incident-investigation/:uuid(" +
      uuidPattern +
      ")",
    name: "incident_investigation_view",
    component: IncidentInvestigationView,
    props: true,
  },
  {
    path:
      "/raft/incident-management/incident-investigation/:uuid(" +
      uuidPattern +
      ")/edit",
    name: "incident_investigation_edit",
    component: IncidentInvestigationForm,
    props: true,
  },
  {
    path:
      "/raft/incident-management/incident-investigation/:uuid(" +
      uuidPattern +
      ")/activity-log",
    name: "incident_investigation_activity",
    component: ActivityLogListing,
    props: true,
  },
  {
    path: "/raft/incident-management/incident-reports",
    name: "incident_reports_listing",
    component: IncidentReportsListing,
    props: true,
  },
  {
    path: "/raft/incident-management/report",
    name: "incident_management_report",
    component: IncidentManagementReport,
    props: true,
  },
  {
    path:
      "/raft/incident-management/incident-investigation/:investigation_uuid(" +
      uuidPattern +
      ")/initial-report/",
    name: "initial_report_view",
    component: IncidentReportView,
    props: true,
    beforeEnter: (to, from, next) => {
      if (to.params.hasOwnProperty("redirect")) {
        return next();
      }
      // Before the route loads, transform the uuid parameter from the investigation node uuid
      // to the report node uuid.
      jsonapiClient.getJSONapi(
        "node/incident_investigation/" + to.params.investigation_uuid,
        {
          "fields[node--incident_investigation]": "field_incident_report",
          "fields[node--incident_report]": "id",
        },
        (response) =>
          next({
            name: "initial_report_view",
            params: {
              investigation_uuid: to.params.investigation_uuid,
              reportUuid:
                response.data.relationships.field_incident_report.data.id,
              redirect: true,
            },
          }),
        (error) => {
          console.error(error); // eslint-disable-line no-console
          next();
        },
        this,
      );
    },
  },
];

const globalComponents = {
  IncidentManagement,
};

export {
  routes as incidentManagementRoutes,
  globalComponents as incidentManagementGlobalComponents,
};
